import api from '../api';

export default class TiposBensService {
  constructor() {
    throw 'Não é possível instanciar TiposBensService';
  }

  static async lista() {
    const endpoint = mergeEndpoint();
    return await api.get(endpoint);
  }
}

const mergeEndpoint = () => {
  return `declaracoes-bens/tipos-itens`;
};



// WEBPACK FOOTER //
// ./src/services/enums/tiposBensService.js